import angular from 'angular';
import uiModal from 'angular-ui-bootstrap/src/modal';
import uiPagination from 'angular-ui-bootstrap/src/pagination';
import {GridComponent} from './grid/grid.js';
import {FormComponent} from './form/form.js';



const pristanak = angular.module('pristanak', [uiModal, uiPagination]);

pristanak.component('pristanakGrid', GridComponent);
pristanak.component('pristanakForm', FormComponent);

export {pristanak};



// WEBPACK FOOTER //
// ./app/components/pristanak/pristanak.js